export const MAX_PASSPORT_NUMBER_LENGTH = 12;
export const MAX_ANOTHER_CITIZENSHIP = 5;
